module.exports = __webpack_public_path__ + "assets/img/E.23440b4f.png";